export enum ArticleListTagRouteName {
    Index = 'system.article.list.tags.index',
    Create = 'system.article.list.tags.create',
    Edit = 'system.article.list.tags.edit',
}

export default {
    path: 'article-list-tags',
    name: ArticleListTagRouteName.Index,
    component: () => import('@/views/system/article-list-tag/Index.vue'),
    meta: {
        auth: true,
        label: 'Article List Tags',
        icon: 'fal fa-folder-tree fa-fw',
        group: 'main',
        location: 'sidebar',
        permission: 'manage-categories',
    },
    children: [
        {
            path: 'create',
            name: ArticleListTagRouteName.Create,
            component: () => import('@/views/system/article-list-tag/Index.vue'),
            meta: {
                auth: true,
                label: 'Create List Tag',
                icon: 'fal fa-folder-tree fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-categories',
            },
        },
        {
            path: ':categoryUuid/edit',
            name: ArticleListTagRouteName.Edit,
            component: () => import('@/views/system/article-list-tag/Index.vue'),
            meta: {
                auth: true,
                label: 'Edit List Tag',
                icon: 'fal fa-folder-tree fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-categories',
            },
        },
    ],
}
